<template lang="html">
  <b-field>
    <template slot="label">
      Language(s)
      <b-tooltip position="is-right" type="is-dark" label="Language(s) used">
        <b-icon size="is-small" icon="help-circle-outline"></b-icon>
      </b-tooltip>
    </template>

    <b-taginput
      v-model="localLanguages"
      :data="filteredLanguages"
      @typing="getFilteredLanguages"
      :allow-new="false"
      autocomplete
      :maxtags="maxTags"
      placeholder="Add a language"
      @input="updateLanguages"
    />
  </b-field>
</template>

<script>
import { languagesMixin } from '@/mixins/languagesMixin'

export default {
  mixins: [languagesMixin],
  props: ['languages', 'maxTags'],
  data () {
    return {
      localLanguages: [],
      filteredLanguages: this.getLanguageNames
    }
  },
  created () {
    this.localLanguages = this.languages
  },
  methods: {
    updateLanguages (value) {
      this.$emit('updateLanguages', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
